export const INSIGHTS_REQUEST = "INSIGHTS_REQUEST";
export const INSIGHTS_SUCCESS = "INSIGHTS_SUCCESS";
export const INSIGHTS_FAILURE = "INSIGHTS_FAILURE";

export const UPDATE_INSIGHT_REQUEST = "UPDATE_INSIGHT_REQUEST";
export const UPDATE_INSIGHT_SUCCESS = "UPDATE_INSIGHT_SUCCESS";
export const UPDATE_INSIGHT_FAILURE = "UPDATE_INSIGHT_FAILURE";
